import React, { useEffect, useState, useRef } from 'react'
import PageApp from '../../../Page';
import { HomeOutlined, UnorderedListOutlined, ExclamationCircleFilled, ClockCircleOutlined } from '@ant-design/icons';
import { Table, Empty, Modal, Form, Divider, Button, message, Space, Skeleton, Tag } from 'antd';
import { getByAnioEmpleado, insert, update, drop } from '../../../../apis/RolTurnoApi';
import AnioPreNomina from '../../../../components/forms/anio_prenomina';
import FormBody from './form'
import { TIPO_DIA_OPTIONS } from '../../../../constants/tipoDia';
import moment from 'moment';
import _ from 'lodash'

const { confirm } = Modal;

const routes = [
    {
        href: '',
        title: <>
            <HomeOutlined />
            <span>Inicio</span>
        </>,
    },
    {
        href: '',
        title: (
            <>
                <UnorderedListOutlined />
                <span>Asistencia</span>
            </>
        ),
    },
    {
        href: '',
        title: (
            <>
                <UnorderedListOutlined />
                <span>Empleados</span>
            </>
        ),
    },
    {
        href: '',
        title: (
            <>
                <ClockCircleOutlined />
                <span>Rol de Turno</span>
            </>
        ),
    }
];

const RolTurnoPage = () => {
    const [form] = Form.useForm()
    const [ID, setID] = useState(null);
    const [items, setItems] = useState([]);
    const [objectSelected, setObjectSelected] = useState(null);
    const [disabledForm, setDisabled] = useState(true);
    const [header, setHeader] = useState(null);
    const [loading, setLoading] = useState(false);
    const [period, setPeriod] = useState(null);
    const [anio, setAnio] = useState(null);

    const getTipoDiaText = (value) => {
        const tipo = TIPO_DIA_OPTIONS.find(t => t.value === value);
        return tipo ? tipo.text : 'N/A';
    };

    const getTipoDiaColor = (value) => {
        const colors = {
            1: 'blue',      // Hábil
            2: 'orange',    // Descanso1
            3: 'orange',    // Descanso2
            4: 'red'        // Festivo
        };
        return colors[value] || 'default';
    };

    const columns = [
        {
            title: 'Empleado',
            dataIndex: ['empleado', 'name'],
            key: 'empleado',
        },
        {
            title: 'Fecha',
            dataIndex: 'fecha',
            key: 'fecha',
            render: (fecha) => fecha ? moment(fecha).format('DD/MM/YYYY') : 'N/A'
        },
        {
            title: 'Horario',
            dataIndex: ['horario', 'name'],
            key: 'horario',
        },
        {
            title: 'Tipo Día',
            dataIndex: 'tipo_dia',
            key: 'tipo_dia',
            render: (tipo_dia) => (
                <Tag color={getTipoDiaColor(tipo_dia)}>
                    {getTipoDiaText(tipo_dia)}
                </Tag>
            )
        },
        {
            title: '',
            dataIndex: 'actions',
            key: 'actions',
            render: (item, object) => {
                return <Space>
                    <Button type='primary' size='small' onClick={() => {
                        onEdit(object);
                    }}>Editar</Button>
                    <Button type='primary' size='small' danger onClick={() => {
                        deleteConfirm(object);
                    }}>Eliminar</Button>
                </Space>
            }
        }
    ];

    const bodyRef = React.createRef();

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            if (!values) return;

            const periodo_id = form.getFieldValue('periodo_id');

            // Convertir el moment a fecha ISO antes de enviar
            const payload = {
                ...values,
                fecha: values.fecha ? values.fecha.format('YYYY-MM-DD') : null,
                periodo_id: periodo_id
            };

            let success = false;

            if (objectSelected?.id > 0) {
                //Update
                payload.id = objectSelected?.id;
                const response = await update(payload);
                success = response.ok;
                if (response.ok) {
                    message.success('Se actualizó correctamente el rol de turno!');
                }
            } else {
                //Create
                const response = await insert(payload);
                success = response.ok;
                if (response.ok) {
                    message.success('Se guardó correctamente el rol de turno!');
                }
            }

            if (success) {
                await resetBody();
                await refreshData();
            }
        } catch (errorInfo) {
            console.log('Failed:', errorInfo);
            message.error('Por favor completa todos los campos obligatorios.');
            return;
        }
    }

    const resetBody = async () => {
        setObjectSelected(null);
        form.resetFields(['empleado_id', 'fecha', 'horario_id', 'tipo_dia',]);
    }

    const onEdit = async (object) => {
        setObjectSelected(object);
    }

    const deleteConfirm = async (item) => {
        confirm({
            title: '¿Confirmas en eliminar el rol de turno?',
            icon: <ExclamationCircleFilled />,
            content: 'No podrás recuperar su información',
            onOk: () => { deleteOk(item.id) },
            onCancel() {
                console.log('Cancel');
            },
        });
    }

    const deleteOk = async (id) => {
        setLoading(true);
        const response = await drop(id);
        if (response.ok) {
            message.success('¡El rol de turno ha sido eliminado!');
        }
        await refreshData();
    }

    const refreshData = async () => {
        if (!anio) return;

        setLoading(true);
        const empleado_id = form.getFieldValue('empleado_id');
        if (!empleado_id) {
            setItems([]);
            setLoading(false);
            return;
        }

        const response = await getByAnioEmpleado(anio, empleado_id);
        if (response.ok) {
            let items = response.payload;
            setItems(items);
        }
        setLoading(false);
    }

    const onBlurHeader = async (values, period) => {
        if (values?.anio) {
            setAnio(values.anio);
            setPeriod(period);
            setDisabled(false);
        } else {
            setAnio(null);
            setPeriod(null);
            setDisabled(true);
            setItems([]);
        }
    }

    return <PageApp
        routes={routes}
        title={'Rol de Turno'}>
        <>
            <AnioPreNomina onBlur={onBlurHeader} form={form} disabledForm={objectSelected && objectSelected.id > 0} />
            <Divider />
            {
                objectSelected && objectSelected.id > 0 &&
                <FormBody ref={bodyRef} onOk={handleOk} onCancel={resetBody} form={form} disabledForm={disabledForm} object={objectSelected} onEmpleadoChange={refreshData} period={period}/>
            }
            {
                !objectSelected &&
                <FormBody ref={bodyRef} onOk={handleOk} form={form} disabledForm={disabledForm} onEmpleadoChange={refreshData} period={period}/>
            }
            <Divider />
        </>

        {
            loading ?
                <Skeleton loading={loading} /> :
                <>
                    {
                        items.length == 0 ? <Empty /> :
                            <Table dataSource={items} columns={columns} />
                    }
                </>
        }
    </PageApp>
}

export default RolTurnoPage;